<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-12-23 23:09:18
 * @LastEditors: 诺
 * @LastEditTime: 2022-01-17 13:39:32
 * @Description: file content
 rule rank prize
 规则、排行、奖品
 -->
<template>
  <div class="mymodal" v-show="value">
    <div class="info">
      <!-- <img class="form-title" src="http://assets.rurushishi.com/activies/hhjx-purchase/form1.png" /> -->
      <img class="modalTitle" :src="configInfo.popupStyleImg" />
      <div class="msg-info" :style="{ backgroundColor: configInfo.popupBackgroundColour }">
        <div class="msgTitle">
          {{ message.type == "thanks" ? "太遗憾了" : "领取奖品" }}
        </div>
        <div class="msg" v-html="text"></div>
        <template class="" v-if="message.type != 'thanks'">
          <div class="msg" v-if="message.lotteryPrizeTimeoutTime">奖品将于{{ parseInt(message.lotteryPrizeTimeoutTime) | dformat }}过期</div>
          <div class="tel-wrap">
            <input @blur="blurInput" v-model="userWriteForm.name" type="text" placeholder="姓名:" />
          </div>
          <div class="tel-wrap">
            <input @blur="blurInput" v-model="userWriteForm.mobile" type="tel" placeholder="手机号码:" />
          </div>
          <div class="tel-wrap select-wrap" v-if="message.prizeType == 2">
            <Multiselect v-model="userWriteForm.address" :options="addressList" placeholder="兑换地址" :searchable="false" :allow-empty="false" :show-labels="false" track-by="address" label="address">
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.address }}
              </template>
            </Multiselect>
          </div>
          <div class="ver-container">
            <input @blur="blurInput" v-model="userWriteForm.code" maxlength="6" oninput="if(value.length>6)value=value.slice(0,6)" type="number" placeholder="验证码:" />
            <div class="ver-btn" @click="clickCode">{{ verShowTxt }}</div>
          </div>
          <div
            class="submit"
            :style="{
              backgroundColor: configInfo.buttonBackgroundColour,
              color: configInfo.buttonTextColour,
            }"
            @click="clickBottomBtn"
          >
            提交
          </div>
        </template>
        <div
          v-else
          class="submit"
          :style="{
            backgroundColor: configInfo.buttonBackgroundColour,
            color: configInfo.buttonTextColour,
          }"
          @click="clickBottomBtnConfirm"
        >
          确定
        </div>
      </div>
      <img class="close" @click="clickClose" src="http://assets.rurushishi.com/activies/activityCenter/turntableLottery/close.png" alt />
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { Toast, MessageBox } from "mint-ui";

export default {
  components: { Multiselect },
  props: {},
  data() {
    return {
      value: false,
      callback: null,
      message: "",
      userWriteForm: {
        name: "",
        mobile: "",
        code: "",
        address: {},
      },
      addressList: [],
      isCanVer: true, //是否能发送验证码
      verShowSec: 60, //读秒
      verShowTxt: "获取验证码",
      ismobile: 0, //1 有电话、0 没电话
      timeInterval: null,
      timeInterval2: null,
      configInfo: {},
      text: "",
    };
  },
  watch: {
    userWriteForm: {
      handler() {
        if (this.userWriteForm.code.length > 6) {
          this.userWriteForm.code = this.userWriteForm.code.substring(0, 6);
        }
      },
      deep: true,
    },
    value: function(newVal) {
      if (newVal) {
        if (this.message.type == "thanks") {
          this.text = `感谢您的参与，分享活动还有更多惊喜，继续加油吧！`;
        } else {
          console.log(this.message.deadline);
          if (this.message.category == 1) {
            let time = parseInt((this.message.deadline - new Date().getTime()) / 1000);
            this.text = `恭喜您获得${this.message.prizeName}，请填写信息领取奖品。`; //<br/>请在${time}秒内领奖.
            this.upDataText(time);
          } else {
            this.text = `恭喜您获得${this.message.prizeName}，请填写信息领取奖品。`;
          }
          if (this.message.type == "helpPrize") {
            this.text = `恭喜您成功帮助好友完成助力！<br/>奖励您一个随机金喜，请正确填写信息后领取。`;
          }
          // 判断是否有地址
          // this.getPrizeById();
          // 打开弹框 message接收prizeInfo
          // 判断是否有电话
          console.log(this.$userInfo);
          this.userWriteForm.name = this.$userInfo ? this.$userInfo.nickname : "";
          this.userWriteForm.mobile = this.$userInfo ? this.$userInfo.phoneNumber : "";
          if (this.message.mobile) {
            this.ismobile = 1;
            this.userWriteForm.mobile = this.message.mobile;
          }
        }
      } else {
        //关闭清空form数据,不清空倒计时
        this.verShowTxt = "获取验证码";
        clearInterval(this.timeInterval2);
        this.userWriteForm = {
          name: "",
          mobile: "",
          code: "",
          address: "",
        };
        this.isCanVer = true; //是否能发送验证码
        this.verShowSec = 60; //读秒
      }
    },
    message: function(newVal, oldval) {
      console.log(newVal, oldval);
      if (oldval != "" && oldval.prizeCode != newVal.prizeCode) {
        // console.log('有变化')
        this.verShowTxt = "获取验证码";
        this.userWriteForm = {
          name: "",
          mobile: "",
          code: "",
          address: "",
        };
        this.isCanVer = true; //是否能发送验证码
        this.verShowSec = 60; //读秒
      }
    },
  },
  computed: {},
  mounted() {
    let configInfo = {
      projectId: "61",
      projectName: "佘山项目",
      actName: "模板预览",
      startTime: 1641484800000,
      endTime: 1642175999000,
      gpsSwitch: 0,
      couponSwitch: 1,
      rankPrizeSwitch: 1,
      watchShowSwitch: 1,
      joinShowSwitch: 1,
      rotationWinSwitch: 1,
      actRule:
        "<p><strong>活动说明：</strong></p>\n<p>文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容文字内容</p>\n<p><strong>活动时间：</strong></p>\n<p>文字内容文字内容文字内容文字内容</p>\n<p><strong>领奖时间：</strong></p>\n<p>文字内容文字内容文字内容文字内容</p>\n<p><strong>优惠券规则：</strong></p>\n<p>文字内容文字内容文字内容文字内容</p>\n<p><strong>排行榜时间：</strong></p>\n<p>文字内容文字内容文字内容文字内容</p>",
      disclaimer: "本次活动最终解释权归开发商所有。",
      backgroundMusicSwitch: 1,
      backgroundMusicUrl: "http://assets.rurushishi.com/activies/rchd-blind-box-2021-11/bgm.mp3",
      backgroundColour: "#B70110",
      mainColour: "#EF1350",
      buttonBackgroundColour: "#F3A92B",
      buttonTextColour: "#FFFFFF",
      popupBackgroundColour: "#FFFFFF",
      backgroundImg: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/bg.png",
      topLogoImg: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/logo.png",
      mainKvImg: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/kv.png",
      wheelBackgroundImg: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/lotteryBg.png",
      wheelBaseImg: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/lotteryBg2.png?v=20220120",
      wheelPointerImg: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/lotteryPointer.png",
      wheelButtonImg: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/draw.png",
      shareButtonStyleImg: "",
      popupStyleImg: "https://assets.rurushishi.com/activies/activityCenter/turntableLottery/prizeImg.png",
      shareSwitch: 1,
      shareTitle: "分享标题",
      shareInfo: "分享描述",
      shareSmallImg: "https://assets-cos-test.yqaitech.com/marcloud/wx01f0b018d4951434/2022140110512707527.jpg",
      shareImg: "https://assets-cos-test.yqaitech.com/marcloud/wx01f0b018d4951434/2022148438013195017.jpg",
      couponTitle: "购房优惠券",
      rankPrizeTitle: "排行榜奖品",
      prizeTitle: "奖品展示",
      salesSiteTitle: "项目展示",
      status: 1,
      receiveAddress: '["这是第一个领奖地址"]',
      lotteryTimesLimitSwitch: 0,
      lotteryTimesDailyLimit: 1,
    };
    if (configInfo.receiveAddress) {
      let addressList = [];
      //   this.addressList = [
      //     { address: "武汉", type: 1 },
      //     { address: "上海", type: 2 },
      //     { address: "北京", type: 3 },
      //   ];
      JSON.parse(configInfo.receiveAddress).map((item, index) => {
        addressList.push({ address: item, type: index });
      });
      this.userWriteForm.address = addressList[0];
      this.addressList = addressList;
    }
    this.configInfo = configInfo;
  },
  methods: {
    //取消领奖
    clickClose() {
      console.log("关闭");
      this.value = false;
      this.callback("cancel");
    },
    upDataText(time) {
      this.timeInterval2 = setInterval(() => {
        time--;
        if (time <= 0) {
          this.$showToast({
            message: "奖品已过期,无法领取",
            duration: 1000,
          });
          this.value = false;
          this.callback("cancel");
        }
        this.text = `恭喜您获得${this.message.prizeName}，请填写信息领取奖品。`; //<br/>请在${time}秒内领奖.
      }, 1000);
    },
    //获取奖品详情
    getPrizeById() {
      let url = this.$apizt.turntable.getPrizeById.api;
      this.$httpdf.get(`${url}`, { prizeId: this.message.prizeId }, { res: "data" }).then((data) => {
        console.log("获取奖品详情: ", data);
        if (data.code != 200) {
          return this.$showToast({
            message: data.msg || "网络连接错误,请重试",
            duration: 1000,
          });
        } else {
          if (data.data.address && data.data.address.length > 0) {
            this.addressList = [];
            data.data.address.forEach((v, i) => {
              let obj = {};
              obj.addressId = v.addressId;
              obj.address = v.addressName;
              obj.name = v.addressName;
              obj.id = i;
              this.addressList.push(obj);
            });
          }
        }
      });
    },
    temporaryRepair() {
      let windowFocusHeight = window.innerHeight;
      if (this.windowHeight == windowFocusHeight) {
        return;
      }
      let currentPosition;
      let speed = 1; //页面滚动距离
      currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    },
    blurInput() {
      this.temporaryRepair();
    },
    // 点击获取验证码
    async clickCode() {
      if (this.isCanVer) {
        var mobile = this.userWriteForm.mobile;
        if (mobile.length == 0) {
          Toast({ message: "请输入手机号", duration: 1000 });
        } else if (!this.$util.isMobile(mobile)) {
          Toast({ message: "请输入正确的手机号！", duration: 1000 });
        } else {
          this.isCanVer = false;
          this.verShowTxt = this.verShowSec + "s";
          this.verShowSec--;
          this.timeInterval = setInterval(() => {
            if (this.isCanVer == false) {
              if (this.verShowSec == 0) {
                this.verShowTxt = "获取验证码";
                this.isCanVer = true;
                this.verShowSec = 60;
                clearInterval(this.timeInterval);
              } else {
                this.verShowTxt = this.verShowSec + "s";
                this.verShowSec--;
              }
            }
          }, 1000);

          //获取验证码
          let param = this.$apizt.action.getSmsCode;
          const { code } = await this.$httpzt.requestRestFul(param, {
            mobile: mobile,
          });
          // if (result) {
          //   console.log(data);
          // }
          if (code == 200) {
            this.$showToast("验证码已发送,请查收!");
          } else {
          }
        }
      }
    },
    //提交事件
    clickBottomBtn() {
      var phone = this.userWriteForm.mobile || "";
      var vercode = this.userWriteForm.code || "";
      if (phone.length == 0 && this.ismobile == 0) {
        Toast({ message: "请输入手机号", duration: 1000 });
      } else if (!this.$util.isMobile(phone) && this.ismobile == 0) {
        Toast({ message: "请输入正确的手机号！", duration: 1000 });
      } else if (vercode.length == 0 && this.ismobile == 0) {
        Toast({ message: "请输入验证码！", duration: 1000 });
      } else {
        // this.$rsh5.actEntry(phone);
        /***********************************/
        if (this.message.type == "helpPrize") {
          // 领取话费
          this.receiveAssistancePrize();
        } else if (this.message.type == "coupon") {
          // 免费领券
          this.receiveCoupon();
        } else {
          // 领取实物
          this.checkField();
        }
      }
    },
    // 领取话费
    receiveassistance() {
      var phone = this.userWriteForm.mobile || "";
      var verCode = this.userWriteForm.code || "";
      if (this.message.prizeType == 3) {
        this.$httpdf
          .post(
            this.$apizt.turntable.awardPrize.api,
            {
              prizeId: this.message.prizeId,
              prizeLogId: this.message.id,
              mobile: phone,
              verCode: verCode,
            },
            {
              res: "data",
            }
          )
          .then((data) => {
            if (data.code == 200) {
              Toast({
                message: "领取成功！",
                duration: 1000,
              });
              setTimeout(() => {
                this.value = false;
                this.callback("ok");
              }, 1000);
            } else {
              this.$showToast({ message: data.msg, duration: 2000 });
            }
          });
      } else {
        let url = this.$apizt.turntable.sendTelFare.api + `?mobile=${phone}&verCode=${verCode}`;
        this.$httpdf
          .post(url, null, {
            res: "data",
          })
          .then((data) => {
            if (data && data.code == 200) {
              Toast({
                message: "领取成功！",
                duration: 1000,
              });
              setTimeout(() => {
                this.value = false;
                this.callback("ok");
              }, 1000);
            } else {
              if (data && data.msg) {
                this.$showModal(data.msg);
              } else {
                this.$showModal("网络不佳，请稍后重试！").then(() => {
                  this.value = false;
                  this.callback("ok");
                });
              }
            }
          });
      }
    },
    // 领取转盘奖品
    async checkField() {
      const { mobile, name, code, address } = this.userWriteForm;
      if (!address) {
        Toast({
          message: "请选择领奖地址",
          duration: 1000,
        });
        return;
      }
      let param = this.$apizt.action.receive;
      const res = await this.$httpzt.requestRestFul(param, {
        address: address.address,
        code: code,
        mobile: mobile,
        name: name,
        receiveKey: this.message.receiveKey,
      });
      if (res.code == 200) {
        this.value = false;
        Toast({
          message: "领取成功",
          duration: 1000,
        });
        this.callback("success");
      }
    },
    async receiveAssistancePrize() {
      // 领取助力奖品
      const { mobile, name, code, address } = this.userWriteForm;
      if (!address) {
        Toast({
          message: "请选择领奖地址",
          duration: 1000,
        });
        return;
      }
      let param = this.$apizt.action.receiveAssistancePrize;
      const res = await this.$httpzt.requestRestFul(param, {
        address: address.address,
        code: code,
        mobile: mobile,
        name: name,
        receiveKey: this.message.receiveKey,
      });
      if (res.code == 200) {
        this.value = false;
        Toast({
          message: "领取成功",
          duration: 1000,
        });
        this.callback("success");
      }
    },
    async receiveCoupon() {
      if (!this.userWriteForm.address) {
        Toast({
          message: "请选择领奖地址",
          duration: 1000,
        });
        return;
      }
      let param = this.$apizt.action.receiveCoupon;
      const { code } = await this.$httpzt.requestRestFul(param, {
        address: this.userWriteForm.address.address,
        code: this.userWriteForm.code,
        mobile: this.userWriteForm.mobile,
        name: this.userWriteForm.name,
        receiveKey: this.message.receiveKey,
      });
      if (code == 200) {
        this.value = false;
        Toast({
          message: "领取成功",
          duration: 1000,
        });
        this.callback("success");
      }
    },
    clickBottomBtnConfirm() {
      this.value = false;
      if (this.configInfo.shareSwitch == 1) {
        let text = {
          text1: "邀请好友",
          text2: "还有更多惊喜",
          text3: "",
        };
        this.$modal.share.alert(text).then((data) => {
          if (data == "save") {
            console.log(this.configInfo.shareImg);
            this.$modal.poster.alert({
              gameBg: this.configInfo.shareImg, //分享截图背景图
            });
          }
        });
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="stylus" scoped>
.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;

  .info {
    position: relative;
    width: 300px;
    display: flex;
    flex-direction:column;
    justify-content: center;
    align-items: center;

    .modalTitle {
      position: relative;
      width: 300px;
      z-index: 1;
    }

    .msg-info {
      position: relative;
      z-index: 0;
      margin-top: -1px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 0px 0px 16px 16px;
      width: 100%;
      box-sizing: border-box;
      padding-bottom: 24px;

      .msgTitle {
        font-weight: 600;
        font-size: 24px;
        line-height: 32px;
        color: #262626;
        margin-top: 10px;
      }

      .msg {
        font-size: 14px;
        line-height: 20px;
        margin-top: 12px;
        color: #595959;
        width: 240px;
        margin-bottom: 12px;
      }

      .tel-wrap, .ver-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 240px;
        height: 40px;
        margin-bottom: 12px;
        font-size: 14px;
      }

      .tel-wrap input {
        width: 240px;
        height: 40px;
        padding: 10px;
        background: #F8F8FB;
        border: 1px solid #EEF0F3;
        box-sizing: border-box;
        border-radius: 6px;
        box-sizing: border-box;
      }

      input::-webkit-input-placeholder {
        color: #595959;
      }

      .ver-container input {
        width: 132px;
        height: 40px;
        padding: 10px;
        background: #F8F8FB;
        border: 1px solid #EEF0F3;
        box-sizing: border-box;
        border-radius: 6px;
        box-sizing: border-box;
      }

      .ver-btn {
        width: 100px;
        height: 40px;
        border: 1px solid #EF1350;
        box-sizing: border-box;
        border-radius: 6px;
        font-weight: 500;
        text-align: center;
        font-size: 14px;
        line-height: 40px;
        color: #EF1350;
      }

      .multiselect {
        height: 40px;
        border-radius: 6px;
      }

      .select-wrap >>> .multiselect__tags {
        height: 40px;
        font-size: 14px;
        padding: 0;
        border-radius: 6px;
        border: 1px solid #EEF0F3;
        background: #F8F8FB;
        padding: 10px;
      }

      .select-wrap >>> .multiselect__placeholder {
        color: #595959;
        line-height: 20px;
        font-family: tahoma, arial, 'Hiragino Sans GB', simsun, sans-serif;
      }

      .select-wrap >>> .multiselect__single {
        font-size: 14px;
        background: transparent;
        padding: 0;
        margin-bottom: 0;
      }

      .submit {
        margin-top: 12px;
        width: 220px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        font-size: 20px;
        border-radius: 24px;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      }
    }

    .close {
      position: relative;
      width: 40px;
      height: 40px;
      z-index: 1002;
      margin-top:28px;
    }
  }
}

.msgbox {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 5.9rem;
}
</style>
